import React, { useState } from 'react';
import { OrderCategory } from '../orderQuery.utils';
import { Accordion, RadioButton } from '@repo/ui/components';
import { IConfiguration } from 'next-common';

interface IRadioButtonGroupType {
  value: OrderCategory;
  label: string;
}

export const categoryOptions: IRadioButtonGroupType[] = [
  {
    label: 'Tilbud',
    value: OrderCategory.OFFER,
  },
  {
    label: 'Ordre',
    value: OrderCategory.ORDER,
  },
  {
    label: 'Utlevert',
    value: OrderCategory.DELIVERED,
  },
  {
    label: 'Annuller',
    value: OrderCategory.CANCEL_ORDER,
  },
];

export interface ICategoryFilterProps {
  configuration?: IConfiguration;
  onChange: (value: OrderCategory) => void;
}

export const CategoryFilter = (props: ICategoryFilterProps) => {
  const [currentActive, setCurrentActive] = useState<string>('OFFER');

  const handleCategory = (value: OrderCategory): void => {
    setCurrentActive(value);
    props?.onChange(value);
  };

  const showAnnullerTab = props?.configuration?.features?.orderCancel?.length < 1;
  const filteredCategory = categoryOptions.filter(
    (category) => !(category.value === OrderCategory.CANCEL_ORDER && showAnnullerTab)
  );

  return (
    <div className="flex flex-col gap-4 py-2 border-y border-neutralGrey">
      <Accordion
        primaryLabel={'Vis'}
        className="border-none outline-none bg-lightGrey"
        triggerClassName="font-extrabold leading-[175%] bg-lightGrey enabled:hover:bg-lightGrey"
        contentClassName="bg-lightGrey"
        defaultOpen
      >
        <div className="flex flex-col gap-4">
          {filteredCategory?.map((button) => (
            <RadioButton
              id={button?.label}
              label={button?.label}
              checked={currentActive === button?.value}
              onChange={(): void => handleCategory(button?.value)}
              labelClassName="mt-0"
            />
          ))}
        </div>
      </Accordion>
    </div>
  );
};
